import { DragOverlay } from '@dnd-kit/core'

interface Props {
  children: React.ReactNode
}

export default function DragOverlayWrapper({ children }: Props) {
  // @ts-expect-error — @dnd-kit types incompatible with @types/react@19
  return <DragOverlay>{children}</DragOverlay>
}
